import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, Validator } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog, MatMenuTrigger } from '@angular/material';
import { LearnerService } from 'src/app/services/learner.service';
import { TimeSheetService } from '../../services/time-sheet.service'
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { EditLearnerModalComponent } from '../edit-learner-modal/edit-learner-modal.component';
import { exists } from 'fs';
import { PolicyService } from '../../services/policy.service'
import { Observable } from 'rxjs';
declare var $;


@Component({
  selector: 'app-add-learner-modal',
  templateUrl: './add-learner-modal.component.html',
  styleUrls: ['./add-learner-modal.component.scss']
})
export class AddLearnerModalComponent implements OnInit {
  loading: Boolean = false;
  confirmPassword = new FormControl('');
  passwordMismatch: boolean;
  learnerForm
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  error: any;
  learnerList = []
  isDisable = false
  isEdit = false
  selectedLearner
  selectedLearnerCopy
  notify = false
  upperCaseLettersValid
  numberValid
  pwdLengthValid
  checkPolicy
  hoursValid: boolean = true
  isAuto: boolean = false
  systemDate
  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;
  isTotalHours: boolean = false;
  // isAuto: boolean = false
  // systemDate

  ngOnInit() {
    console.log("pass data from main page", this.data);

    if (this.data.jobDetails.course.trackHours == true)
      this.isTotalHours = true

    this.createForm(this.data)

    this.confirmPassword.setErrors({
      nomatch: true
    });

    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });



  }
  constructor(
    public _EncryptDecryptService: EncryptDecryptService,
    public _policyService: PolicyService,
    public _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _learnerService: LearnerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public timeSheetService: TimeSheetService
  ) {
    // NO DEFINITION
    this.timeSheetService.newDateObservable().subscribe((date) => {
      console.log("system date get", date);
      this.systemDate = date
    })
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return false;
    if (!data.email) return false;
    if (!data.password) return false;
    if (!data.confirmPassword) return false;
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false;
    }
    this.passwordMismatch = false;
    return true;
  }


  createForm(editData?) {

    this.learnerForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.required),
      // password:new FormControl((editData && editData.password) ? editData.password : ''),
      password: new FormControl((editData && editData.password) ? editData.password : '', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : '', Validators.required),
      notify: new FormControl((editData && editData.notify) ? editData.notify : false),
      totalOTJH: new FormControl('00:00')
    },
      {
        validator: this._policyService.passwordMatchValidator
      })

    if (this.data && this.data.multiple) {
      let date = new Date(this.data.date).toLocaleDateString()

      let dateWeek = this.getDates(new Date('2021-06-29'), new Date('2021-07-31'))
      let checked = dateWeek.includes(date)
      console.log("check date======>", checked);
      if (checked) {
        console.log("this is date week ========", dateWeek, date, checked);
        this.learnerForm.get('password').setValidators([Validators.required]);
        this.learnerForm.get('password').updateValueAndValidity();
        this.checkPolicy = checked
      } else {
        console.log("this is not for using policy", checked);
        this.checkPolicy = checked
      }
    }
    if (this.isEdit) {
      // this.learnerForm.controls['name'].disable()
      // this.learnerForm.controls['password'].disable()
      // this.learnerForm.controls['confirmPassword'].disable()
    }
  }



  addTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9]{1,3}):[0-5][0-9]$/g)
    this.hoursValid = regex.test(event.target.value);
    if (this.hoursValid) {

      console.log("this.houursValid", this.hoursValid)
      // this.totalWorkingHours()
    } else {
      console.log("this is not valid");

    }

  }


  getDates(start, end) {
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt).toLocaleDateString());
    }
    return arr;
  }

  editLearner() {
    console.log("edit learner details", this.selectedLearner);
    this.openDialog(EditLearnerModalComponent, this.selectedLearner).subscribe((response) => {
      console.log("response of edit lerner", response);
      // this.data['_id'] = response.data._id,
      //   this.data['name'] = response.data.name,
      //   this.data['']
      if (response != undefined) {
        this.learnerForm.controls.password.setValue(this._EncryptDecryptService.decrypt(response.data.password));
        this.learnerForm.controls.confirmPassword.setValue(this._EncryptDecryptService.decrypt(response.data.password));
        console.log("what is the form value after update", this.learnerForm.value);

        this.doSubmit()
      } if (response == undefined) {
        this.selectedLearnerCopy['password'] = this._EncryptDecryptService.encrypt(this.selectedLearner.password)

        this.selectedLearner = this.selectedLearnerCopy
        console.log("what is the edit value", this.selectedLearner);

      }

    })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  // onKeyPress(x) {
  //   this.clickMenuTrigger.openMenu();
  //   // console.log("value of password", this.passwords);
  // }

  // closeModel() {
  //   this.clickMenuTrigger.closeMenu();
  // }

  doSubmit() {
    console.log("HERE LEARNER FORM SUBMIT VALUE ?>>>>>", this.learnerForm.value)
    console.log("Submit ", this.data);
    // console.log("Validating = ", this.validate(this.data));

    // if (!this.validate(this.data)) {
    //   console.log("RETURNING");
    //   return;
    // }

    // let learner = {
    //   _id: this.data._id,
    //   name: this.data.name,
    //   job: this.data.job,
    //   email: this.data.email,
    //   password: this._EncryptDecryptService.encrypt(this.data.password),
    //   confirmPassword: this._EncryptDecryptService.encrypt(this.data.confirmPassword),
    //   notify: this.notifyUser
    // }

    let newPassword = this._EncryptDecryptService.encrypt(this.learnerForm.get('password').value)
    this.learnerForm.value.password = newPassword;
    this.learnerForm.value.confirmPassword = newPassword;

    let learner = this.learnerForm.value
    learner['job'] = this.data.job
    learner['_id'] = this.data._id

    if (this.data && this.data.exits) {
      learner['exists'] = this.data.exits
    }
    if (this.data && this.data.jobDetails && this.data.jobDetails.course && this.data.jobDetails.course.courseMetaId && this.data.jobDetails.course.courseMetaId.allocation == true) {
      learner['allocation'] = true
    } else {
      learner['allocation'] = false
    }
    learner['checkPolicy'] = this.checkPolicy


    console.log('Learner Data:', learner, this.data);


    // Do Submit
    this.loading = true;
    this._learnerService.addLearner(learner).subscribe(data => {
      this.data = data;
      this.loading = false;
      console.log("Added Successfully", data);
      this.dialogRef.close(data);
      // this.openSnackBar('Learner Added Successfully', 'OK')
    }, error => {
      console.log('Error', error);
      this.error = error.msg ? error.msg : error
      // this.openSnackBar(error, "Ok");
      this.loading = false;
      // this.dialogRef.close(null);
    });

  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

  onKeyPress(x) {
    this.clickMenuTrigger.openMenu();
    // console.log("value of password", this.passwords);
  }
  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  multipleLearnerList(event) {
    console.log("what is event", event);

    if (event) {

      this.isEdit = false
      console.log("event for add new learner", event);
      console.log("single job data", this.data.job);
      this.isDisable = false
      this.data.password = ''
      this.data.confirmPassword = '';

      // this.data = {}
      let obj = {
        jobId: this.data.job,
        searchKey: event
      }

      this._learnerService.getLearanerList(obj).subscribe((response) => {
        console.log("response of learner list which are not in project", response);
        if (response && response.length) {
          this.learnerList = response
          this.data.name = ''
        } else {
          this.learnerList = []
        }

      }, error => {
        console.log("erorr while get lerner list", error);

      })

    } else {
      console.log("call this else part");
      this.data.password = ''
      this.data.confirmPassword = '';
      this.data.name = ''
      this.learnerList = []
    }

  }

  selectLearner(event) {
    console.log("what is the event", event);
    let obj = {
      name: event.name,
      password: event.password,
      email: event.email,
      _id: event._id,
      exits: true
    }
    this.selectedLearner = obj
    this.selectedLearnerCopy = obj

    this.data.password = this._EncryptDecryptService.decrypt(event.password)

    console.log("what  is the password", this._EncryptDecryptService.decrypt(event.password));


    this.data.confirmPassword = this.data.password;
    this.data.name = event.name
    this.data.email = event.email
    this.isDisable = true
    // this.data['multiple']=true
    this.data['exits'] = true
    this.data['_id'] = event._id
    console.log("what is the value of data==============", this.data);
    this.createForm(this.data)
    this.isEdit = true
    this.learnerList = []
  }

  emailBlurEvent(event) {
    console.log("event when email field change", event);
    // this.learnerList = []
  }


}
